import { Icons as Icon } from '../Icons/Icons';
import { Accordion } from 'components';

import styles from './styles.module.scss';
import classNames from 'classnames';
import {
  ActivityValues,
  ClientsValues,
  DualValues,
  ListingValues,
  PurchaseValues,
  SymphonyColumns,
} from './helpers';

export const Columns = ({
  className = '',
  dropdown = false,
  type = undefined,
  columns = SymphonyColumns,
  setColumns,
}) => {
  return (
    <div className={classNames(className, styles.accordions)}>
      {[
        { title: 'Activity', icon: Icon.ACTIVITY, values: ActivityValues },
        { title: 'Clients', icon: Icon.CLIENTS, values: ClientsValues },
        { title: 'Listings', icon: Icon.LISTING, values: ListingValues },
        { title: 'Purchases', icon: Icon.PURCHASE, values: PurchaseValues },
        { title: 'Dual', icon: Icon.DUAL, values: DualValues },
      ]
        ?.filter(({ icon }) => (type ? icon === type : true))
        ?.map(({ title, icon, values }) => (
          <Accordion
            open={dropdown}
            className={styles.accordion}
            titleClassName={classNames(styles.titleClassName, { [styles.gap]: dropdown })}
            accordionOpenedClass={classNames(styles.accordionOpen, { [styles[icon]]: !dropdown })}
            previewClassName={styles.previewClassName}
            iconContainerClassName={styles.iconContainer}
            title={() => (
              <>
                <Icon
                  className={classNames(styles.accordionIcon, { [styles[icon]]: !dropdown })}
                  variant={icon}
                />
                <span className={styles.accordionTitle}>{title}</span>
              </>
            )}
          >
            <div className={styles.accordionContent}>
              {values.map(({ value, title }) => {
                const currentValues = columns[icon] || [];
                const valueExists = currentValues.includes(value);
                return (
                  <div
                    className={classNames(styles.pill, { [styles[icon]]: valueExists })}
                    onClick={() =>
                      setColumns({
                        ...columns,
                        [icon]: valueExists
                          ? currentValues.filter((v) => v !== value)
                          : [...currentValues, value],
                      })
                    }
                  >
                    {title}
                  </div>
                );
              })}
            </div>
          </Accordion>
        ))}
    </div>
  );
};
